



import {Component, Prop, Vue} from 'vue-property-decorator';

const SvgRender = () => import('@/components/Atoms/SvgRender/SvgRender.vue')

import {MediaInterface} from "@/share/types/interface";
import {MEDIA_TYPE} from "@/constants";

@Component({
  components: {SvgRender}
})

export default class StepMedia extends Vue {
  @Prop() medias?: MediaInterface[]

  private getMediaIcon(type: number): string {
    if (type == MEDIA_TYPE.VIDEO) return 'media-video'
    if (type == MEDIA_TYPE.SALON) return 'media-salon'
    if (type == MEDIA_TYPE.LIVE) return 'media-live'
    if (type == MEDIA_TYPE.EXTERNAL) return 'media-web'
    return ''
  }

  private onClickToMediaLink(url: string): void {
    window.open(url, "_blank");
  }
}
